var _path, _path2, _rect, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBuste = function SvgBuste(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 27 27"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.3,
    d: "m11.16 12.25-.126.944a1.42 1.42 0 0 1-.835 1.111l-5.166 2.282a1.42 1.42 0 0 0-.365 2.366l3.894 3.429c.26.228.594.354.94.354h7.602c.346 0 .68-.126.94-.354l3.893-3.429a1.42 1.42 0 0 0-.365-2.366l-5.166-2.282a1.42 1.42 0 0 1-.834-1.11l-.127-.945M9.395 22.75h7.816L18.63 26H7.975z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    d: "M17.265 9.791a5.39 5.39 0 1 0-7.93 0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 7.937,
    height: 10.068,
    x: 9.334,
    y: 2.781,
    stroke: "currentColor",
    strokeWidth: 1.3,
    rx: 3.968
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeWidth: 1.3,
    d: "M17.921 14.92a4.6 4.6 0 0 1-1.084 1.495 5 5 0 0 1-1.621.998 5.4 5.4 0 0 1-1.913.35c-.657 0-1.307-.12-1.913-.35a5 5 0 0 1-1.622-.998 4.6 4.6 0 0 1-1.084-1.494"
  })));
};
export default SvgBuste;